<script setup lang="ts">
const scales = [13, 14, 15, 16, 17];
const activeScale = ref(scales[2]);

function initScale() {
  let persisted = localStorage.getItem('page-scale');
  if (!persisted) {
    const defSize = scales[2].toString();
    localStorage.setItem('page-scale', defSize);
    persisted = defSize;
  }
  document.documentElement.style.fontSize = `${persisted}px`;
  activeScale.value = Number(persisted);
}

function setScale(scale: number) {
  if (!scales.includes(scale))
    return;
  document.documentElement.style.fontSize = `${scale}px`;
  localStorage.setItem('page-scale', scale.toString());
  activeScale.value = scale;
}

initScale();
</script>

<template>
  <div class="flex items-center gap-2">
    <Button
      icon="pi pi-minus"
      size="small"
      text
      rounded
      :pt="{ root: 'w-5 h-5 p-3' }"
      @click="setScale(activeScale - 1)"
    />
    <i
      v-for="scale in scales"
      :key="`scale-${scale}`"
      class="block h-3 w-3 cursor-pointer rounded-full"
      :class="[scale === activeScale ? 'bg-primary-500' : 'bg-gray-300']"
      @click="setScale(scale)"
    />
    <Button
      icon="pi pi-plus"
      size="small"
      text
      rounded
      :pt="{ root: 'w-5 h-5 p-3' }"
      @click="setScale(activeScale + 1)"
    />
  </div>
</template>

<style scoped>

</style>
